"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  baseUrl: "",
  headers: {
    "Content-Type": "application/json"
  },
  timeout: 100000,
  method: "",
  defaultData: {},
  data: {},
  auth: {},
  resource: "",
  path: "",
  validResponseJSON: true
};
exports["default"] = _default;